import { createAction, props } from '@ngrx/store';

export const gridReady = createAction(
  '[Create Request - Positions Table] Positions AG Grid Ready',
  props<{ gridReady: boolean}>()
)

export const refresh = createAction(
  '[Create Request - Positions Table] Refresh Position Lots Data',
  props<{ accountId: string }>()
);

export const printClicked = createAction(
  '[Create Request - Positions Table] User Requested Printout'
);

export const toAccountNotInContext = createAction(
  '[Create Request - Positions Table] Cannot Load positions table until ToAccount is set'
);

export const loadEdit = createAction(
  '[Create Request - Positions Table] Load Edit Positions Table'
);

export const loadEditComplete = createAction(
  '[Create Request - Positions Table] Finished loading Positions Table with edit info'
);